// extracted by mini-css-extract-plugin
export default {"container":"styles_container__WeEf1","action":"styles_action__x-Grf"};